import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class UserService extends RestService {
  endpoint(): string {
    return "users";
  }
  param1(): string {
    return "";
  }

  param2(): string {
    return "";
  }

  param3(): string {
    return "";
  }
}


